import React from 'react';
import cn from 'classnames';
import stl from './sideMenuHeader.css';
function SideMenuHeader(props) {
    var text = props.text, className = props.className;
    return (React.createElement("div", { className: cn(className, stl.label, "uppercase color-gray") }, text));
}
export default SideMenuHeader;
